"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
export default function Projects() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const topics = [{
    title: "Estetik Dolgu Nedir?",
    content: "Estetik dolgu, diş renginde özel kompozit materyaller kullanılarak dişte oluşan çürük veya hasarlı alanların restore edilmesi işlemidir. Kayseri’de estetik dolgu tedavisi, metal içerikli eski dolgulara göre çok daha doğal bir görünüm sunar. Işıkla sertleşen bu materyaller sayesinde diş yapısına güçlü bir şekilde tutunma sağlanır ve uzun ömürlü sonuçlar elde edilir."
  }, {
    title: "Estetik Dolgu Nasıl Yapılır?",
    content: "Kayseri’de estetik dolgu tedavisi, detaylı diş muayenesi ile başlar. Çürük veya hasarlı doku temizlendikten sonra diş yüzeyi hazırlanır ve katmanlar halinde kompozit dolgu uygulanır. Her katman özel ışık ile sertleştirilir ve son aşamada dolgu diş formuna uygun şekilde şekillendirilerek cilalanır. Bu sayede hem estetik hem de doğal bir görünüm elde edilir."
  }, {
    title: "Estetik Dolgunun Avantajları",
    content: "Kayseri’de estetik dolgu tedavisi, diş dokusunu koruyan yapısı ile öne çıkar. Diş rengi ile uyumlu olması sayesinde dışarıdan fark edilmez ve doğal bir görünüm sağlar. Tek seansta tamamlanabilmesi, hızlı ve konforlu bir çözüm sunması en önemli avantajlarındandır. Ayrıca modern kompozit materyaller sayesinde dayanıklılığı da oldukça yüksektir."
  }, {
    title: "Kimler İçin Uygundur?",
    content: "Kayseri’de estetik dolgu tedavisi; dişlerinde çürük, kırık, çatlak veya eski dolgu problemi olan kişiler için uygundur. Aynı zamanda dişlerindeki küçük şekil bozukluklarını düzeltmek isteyen hastalar için de estetik bir çözüm sunar. Ön dişlerde doğal görünüm isteyen hastalar tarafından sıklıkla tercih edilir."
  }, {
    title: "Kayseri Estetik Dolgu Fiyatları\xA0",
    content: "Kayseri’de estetik dolgu fiyatları; dolgu yapılacak diş sayısı, çürüğün derinliği ve tedavi kapsamına göre değişiklik göstermektedir. En doğru fiyat bilgisi için kliniğimizde yapılacak muayene sonrası kişiye özel planlama yapılır. Kayseri’de estetik dolgu yaptırmak ve doğal görünümlü sağlıklı dişlere sahip olmak için hemen bizimle iletişime geçebilirsiniz."
  }, {
    title: "Neden Bizi Seçmelisiniz?",
    content: "Kayseri'de merkezi konumdaki modern kliniğimizde, güncel teknoloji ve hasta memnuniyeti odaklı yaklaşımımızla estetik ve fonksiyonel sonuçlar sunuyoruz."
  }];
  return <section data-section-id="184775" id="kayseri-implant-tedavisi" className="relative bg-linear-to-b from-background to-secondary/20 py-32 md:py-48 lg:py-56 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        <div ref={headerRef} className={`flex flex-col items-center text-center max-w-4xl mx-auto mb-20 md:mb-32 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-sans text-xs md:text-sm font-semibold tracking-widest uppercase text-primary mb-6">
            Öne Çıkan Tedavilerimiz
          </span>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-8xl text-foreground leading-tight tracking-tight">Kayseri Estetik Dolgu Tedavisi</h2>
          <Separator className="w-24 bg-primary/40 mt-10" />
        </div>

        <div className={`transition-all duration-1000 delay-300 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
            {topics.map((topic, i) => <Card key={i} data-index={i} className="group bg-card/50 backdrop-blur-sm border-none shadow-sm hover:shadow-md hover:bg-secondary/30 transition-all duration-500">
                <CardHeader className="pb-4">
                  <CardTitle className="font-serif text-2xl md:text-3xl text-foreground group-hover:text-primary transition-colors duration-300">
                    {topic.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-muted-foreground leading-relaxed">
                    {topic.content}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>

      </div>
    </section>;
}